/* eslint-disable max-len */
/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2025 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 * */

/**
 * Open Book Icon
 *
 * @file OpenBookIcon.jsx
 * @author Anuja Gaikwad
 * @since 1.0.21
 */

import React from 'react';
import PropTypes from 'prop-types';
import SvgIcon from '@mui/material/SvgIcon';

function OpenBookIcon({ className, sx, ...props }) {
  return (
    <SvgIcon
      {...props}
      className={className}
      viewBox="0 0 18 18"
      sx={{
        width: 16,
        height: 16,
        fontSize: 16,
        ...sx
      }}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.6238 1.52742C14.2375 1.41567 12.8265 1.64605 11.4778 2.20912C10.8611 2.46657 10.2634 2.79112 9.69231 3.178L9.69231 15.1766C10.1106 14.9357 10.5405 14.7227 10.9799 14.5393C12.5134 13.8991 14.1292 13.6326 15.7265 13.7614L15.8428 13.7708L15.7914 14.5187L15.8428 13.7708C16.1018 13.7916 16.3595 13.8224 16.6154 13.8628L16.6154 1.65122C16.3262 1.59873 16.0342 1.56051 15.74 1.53679L15.6238 1.52742ZM9.3899 17.1203C10.0512 16.6386 10.7514 16.2422 11.4778 15.9389C12.8265 15.3759 14.2375 15.1455 15.6238 15.2573L15.74 15.2666C16.2182 15.3052 16.6906 15.382 17.1543 15.4962C17.3596 15.5467 17.575 15.4933 17.7396 15.351C17.9042 15.2087 18 14.993 18 14.7648L18 1.035C18 0.684823 17.7763 0.381249 17.4611 0.303651C16.9302 0.172944 16.3895 0.0850019 15.8428 0.0409264L15.7265 0.0315572C14.1292 -0.0972037 12.5134 0.169234 10.9799 0.809455C10.2942 1.09575 9.63162 1.45395 9 1.878C8.36837 1.45395 7.70584 1.09575 7.0201 0.809455C5.4866 0.169234 3.87076 -0.0972037 2.27346 0.0315575L2.15723 0.0409268C1.61047 0.0850021 1.06984 0.172943 0.538898 0.303648C0.223688 0.381246 0 0.68482 0 1.035L0 14.7648C0 14.993 0.095835 15.2087 0.260403 15.351C0.424972 15.4933 0.640382 15.5467 0.845718 15.4962C1.30941 15.382 1.78183 15.3052 2.25998 15.2666L2.37621 15.2573C3.76248 15.1455 5.1735 15.3759 6.52219 15.9389C7.24891 16.2423 7.94929 16.6389 8.61083 17.1209C8.61907 17.1269 8.62745 17.1328 8.63597 17.1385C8.67337 17.1636 8.7125 17.1844 8.75278 17.2011C8.84386 17.2389 8.94027 17.2549 9.03566 17.2496C9.1464 17.2434 9.25578 17.2084 9.35385 17.1452C9.36614 17.1373 9.37816 17.129 9.3899 17.1203ZM8.30769 15.1766L8.30769 3.17801C7.73658 2.79112 7.13887 2.46658 6.52219 2.20912C5.1735 1.64605 3.76248 1.41567 2.3762 1.52742L2.25998 1.53679C1.96579 1.56051 1.67377 1.59873 1.38462 1.65122L1.38462 13.8628C1.64053 13.8224 1.89819 13.7916 2.15723 13.7708L2.27346 13.7614L2.32484 14.5093L2.27346 13.7614C3.87077 13.6326 5.48661 13.8991 7.0201 14.5393C7.4595 14.7227 7.88937 14.9357 8.30769 15.1766Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
}

OpenBookIcon.propTypes = {
  className: PropTypes.string,
  sx: PropTypes.oneOfType([PropTypes.object, PropTypes.array, PropTypes.func])
};

OpenBookIcon.defaultProps = {
  className: undefined,
  sx: undefined
};

export default OpenBookIcon;
